import enCommon from "./locales/en/common";
import enLayout from "./locales/en/layout";
import enHome from "./locales/en/home";
import enCommerce from "./locales/en/commerce";
import enStub from "./locales/en/stub";
import enAuth from "./locales/en/auth";
import enPages from "./locales/en/pages";
import heCommon from "./locales/he/common";
import heLayout from "./locales/he/layout";
import heHome from "./locales/he/home";
import heCommerce from "./locales/he/commerce";
import heStub from "./locales/he/stub";
import heAuth from "./locales/he/auth";
import hePages from "./locales/he/pages";
import thCommon from "./locales/th/common";
import thLayout from "./locales/th/layout";
import thHome from "./locales/th/home";
import thCommerce from "./locales/th/commerce";
import thStub from "./locales/th/stub";
import thAuth from "./locales/th/auth";
import thPages from "./locales/th/pages";
import type { LocaleCode } from "./locales";

// English defines the canonical key shape. `npm run i18n:validate` verifies
// that Hebrew and Thai contain the same leaf keys.
export const translations = {
    en: { common: enCommon, layout: enLayout, home: enHome, commerce: enCommerce, stub: enStub, auth: enAuth, pages: enPages },
    he: { common: heCommon, layout: heLayout, home: heHome, commerce: heCommerce, stub: heStub, auth: heAuth, pages: hePages },
    th: { common: thCommon, layout: thLayout, home: thHome, commerce: thCommerce, stub: thStub, auth: thAuth, pages: thPages }
} as const;

export type TranslationTree = (typeof translations)["en"];
export function localeTranslations(locale: LocaleCode): TranslationTree {
    return translations[locale] as unknown as TranslationTree;
}
